<h1 class="text-center">DESIGN SYSTEM / UI Style Guide</h1>


<h2 style="text-align: center;">LES BOUTTONS</h2>
<div class="d-flex mb-5" style="gap: 20px;  justify-content: center;">
  <button class="btn-primary">primary</button>
  <button class="btn-secondary">secondary</button>
  <button class="btn-outline-primary">outline primary</button>
  <button class="btn-outline-secondary">outline secondary</button>
</div>


<h2 style="text-align: center;">LES COULEURS</h2>
<div class="d-flex mb-5" style="gap: 20px;  justify-content: center;">
  <div style="width: 40px; height: 40px; background-color: var(--color-primary);"></div>
  <div style="width: 40px; height: 40px; background-color: var(--color-secondary);"></div>
</div>


<h2 style="text-align: center;">LES FONDS</h2>
<div class="d-flex mb-5 px-3" style="gap: 20px;  justify-content: center;">
  <div class="p-2" style="width: calc(100% / 3); background-color: var(--surface); border: 1px solid var(--color-primary);">
    <p>Surface</p>
    <p>Text 1</p>
    <p>Text 2</p>
    <p>Text 3</p>
    <p>Text 4</p>
    <p>Text 5</p>
  </div>
  <div class="p-2" style="width: calc(100% / 3); background-color: var(--bg-primary); border: 1px solid var(--color-primary);">
    <p>Background 1</p>
    <p>Text 1</p>
    <p>Text 2</p>
    <p>Text 3</p>
    <p>Text 4</p>
    <p>Text 5</p>
  </div>
  <div class="p-2" style="width: calc(100% / 3); background-color: var(--bg-secondary); border: 1px solid var(--color-primary);">
    <p>Background 2</p>
    <p>Text 1</p>
    <p>Text 2</p>
    <p>Text 3</p>
    <p>Text 4</p>
    <p>Text 5</p>
  </div>
</div>


<h2 style="text-align: center;">LES BALISES</h2>
<div class="mb-5 text-center" style="gap: 20px;  justify-content: center;">
  <h1>Texte h1</h1>
  <h2>Texte h2</h2>
  <h3>Texte h3</h3>
  <h4>Texte h4</h4>
  <h5>Texte h5</h5>
  <h6>Texte h6</h6>
  <p>Texte paragraphe</p>
  <span>Texte span</span>
  <br>
  <small>Texte small</small>
</div>
